import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { RouteLink, useCurrentRoute } from '../lib/router';
import { WhatsAppButton } from './WhatsAppButton';
const NAV_ITEMS = [{
  label: 'Stay Overnight',
  to: '/stay'
}, {
  label: 'Pines Membership',
  to: '/membership'
}, {
  label: 'Retreat Space',
  to: '/space'
}, {
  label: 'About',
  to: '/about'
}];
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const currentRoute = useCurrentRoute();
  return <header className="sticky top-0 z-50 border-b border-pine/10 bg-cream/95 backdrop-blur-md" data-id="element-523" data-mp="qx5hvo3np3k0">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-10" data-id="element-524" data-mp="14wy8ljf6njrz">
        <RouteLink to="/" className="font-serif text-xl tracking-wide text-pine transition-colors hover:text-ember md:text-2xl" aria-label="Pines Retreat home" data-id="element-525" data-mp="zwskgd84gfen">
          Pines Retreat
        </RouteLink>

        <nav aria-label="Primary navigation" className="hidden items-center gap-7 lg:flex" data-id="element-526" data-mp="2bda7xntqr7p5">
          {NAV_ITEMS.map(item => <RouteLink key={item.to} to={item.to} className={`text-sm font-medium tracking-wide transition-colors ${currentRoute === item.to ? 'text-ember' : 'text-pine hover:text-ember'}`} data-id="element-527" data-mp="29jajljadweb1">
              {item.label}
            </RouteLink>)}
        </nav>

        <button type="button" onClick={() => setMenuOpen(open => !open)} className="inline-flex h-10 w-10 items-center justify-center rounded-sm border border-pine/20 text-pine transition-colors hover:border-pine hover:bg-pine/5 lg:hidden" aria-expanded={menuOpen} aria-controls="mobile-navigation" aria-label={menuOpen ? 'Close navigation' : 'Open navigation'} data-id="element-528" data-mp="2ohcihg6h0bly">
          {menuOpen ? <X className="h-5 w-5" data-id="element-529" data-mp="25hypp1kh96x1" /> : <Menu className="h-5 w-5" data-id="element-530" data-mp="25ja0vmg95gy6" />}
        </button>
      </div>

      {menuOpen && <nav id="mobile-navigation" aria-label="Mobile navigation" className="border-t border-pine/10 bg-cream px-5 py-5 lg:hidden" data-id="element-531" data-mp="183mf6bn6drdd">
          <div className="mx-auto flex max-w-7xl flex-col gap-1" data-id="element-532" data-mp="1d033p6yae7qz">
            {NAV_ITEMS.map(item => <RouteLink key={item.to} to={item.to} onClick={() => setMenuOpen(false)} className={`rounded-sm px-4 py-3 text-base font-medium transition-colors ${currentRoute === item.to ? 'bg-pine text-cream' : 'text-pine hover:bg-pine/5'}`} data-id="element-533" data-mp="14z5716lrcckf">
                {item.label}
              </RouteLink>)}
            <WhatsAppButton variant="primary" label="Message Zev on WhatsApp" className="mt-3 w-full" data-id="element-534" data-mp="19uask4b8zp7z" />
          </div>
        </nav>}
    </header>;
}